import React, {Component} from "react";
import UsersPage from "../users/UsersPage/UsersPage";
import Sidebar from "../../../layout/sidebar/Sidebar";
import Main from "../../../layout/main/Main";
import {Redirect, Route, Switch} from "react-router-dom";
import UserPage from "../user/UserPage/UserPage";
import TeamsPage from "../teams/TeamsPage";
import TeamPage from "../team/TeamPage";
import SwitchUser from "../switch-user/SwitchUser/SwitchUser";
import AppManager from "../app/AppManager/AppManager";
import EventsPage from "../events/EventsPage/EventsPage";
import UploadPage from "../upload/UploadPage/UploadPage";
import StatisticsPage from "../statistic/StatisticsPage";
import CouponPage from "../coupon/CouponPage/CouponPage";
import RequestAccPage from "../affiliate/request-acc/RequestAccPage";
import AffiliateUserPage from "../affiliate/users/AffiliateUserPage";
import ConversionPage from "../affiliate/conversion/ConversionPage";
import WithdrawalPage from "../affiliate/withdrawal/WithdrawalPage";
import ListClicksPage from "../affiliate/list-clicks/ListClicksPage";
import BillingsPage from "../billings/BillingsPage/BillingsPage"
import WorkersPageContainer from "../workers/components/WorkersPageContainer"
import ProxiesPageContainer from "../proxies/component/ProxiesPageContainer"
import KeywordsPage from "../keywords/components/KeywordsPage"
import AccountsPageContainer from "../accounts/AccountsPageContainer";

class Dashboard extends Component {
    render() {
        return (
            <div className="Dashboard container-fluid">
                <div className="row">
                    <Sidebar/>
                    <Main>
                        <Switch>
                            <Redirect exact from="/a" to="/a/users"/>

                            <Route path="/a/users/:userId" component={UserPage}/>
                            <Route path="/a/users" component={UsersPage}/>

                            <Route path="/a/switch-user/:userId" component={SwitchUser}/>

                            <Route path="/a/teams/:teamId" component={TeamPage}/>
                            <Route path="/a/teams" component={TeamsPage}/>

                            <Route exact path="/a/app" component={AppManager}/>
                            <Route path="/a/events" component={EventsPage}/>
                            <Route exact path="/a/upload" component={UploadPage}/>
                            <Route path="/a/coupon" component={CouponPage}/>
                            <Route path="/a/billings" component={BillingsPage}/>
                            <Route path="/a/workers" component={WorkersPageContainer}/>
                            <Route path="/a/accounts" component={AccountsPageContainer}/>
                            <Route path="/a/keywords" component={KeywordsPage}/>
                            <Route path="/a/proxies" component={ProxiesPageContainer}/>
                            <Redirect exact from="/a/affiliate" to="/a/affiliate/users"/>
                            <Route path="/a/affiliate/requests" component={RequestAccPage}/>
                            <Route path="/a/affiliate/users" component={AffiliateUserPage}/>
                            <Route path="/a/affiliate/conversions" component={ConversionPage}/>
                            <Route path="/a/affiliate/withdrawal" component={WithdrawalPage}/>
                            <Route path="/a/affiliate/clicks-statistic" component={ListClicksPage}/>
                            <Route exact path="/a/statistics" component={StatisticsPage}/>
                        </Switch>
                    </Main>
                </div>
            </div>
        );
    }
}

Dashboard.propTypes = {};

export default Dashboard;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard/Dashboard.js